import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Exam } from "types/Exam";

export interface ExamGroupState {
  loading: boolean;
  currentExamGroup: Exam[];
  currentExamGroupRightKnee: Exam[];
  currentExamGroupLeftKnee: Exam[];
  currentExamGroupDoubleKnee: Exam[];
}

const initialState: ExamGroupState = {
  loading: false,
  // minMaxFrames: {} as MinMaxFrames,//TODO: Remove it when is working withe the new ExamMLResult store
  currentExamGroup: [],
  currentExamGroupRightKnee: [],
  currentExamGroupLeftKnee: [],
  currentExamGroupDoubleKnee: [],
};

export const examGroupSlice = createSlice({
  name: "examGroupSlice",
  initialState,
  reducers: {
    setCurrentExamGroup: (state, { payload }: PayloadAction<Exam[]>) => {
      state.currentExamGroup = payload;
    },
    setCurrentExamGroupRightKnee: (state, { payload }: PayloadAction<Exam[]>) => {
      state.currentExamGroupRightKnee = payload;
    },
    setCurrentExamGroupLeftKnee: (state, { payload }: PayloadAction<Exam[]>) => {
      state.currentExamGroupLeftKnee = payload;
    },
    setCurrentExamGroupDoubleKnee: (state, { payload }: PayloadAction<Exam[]>) => {
      state.currentExamGroupDoubleKnee = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setCurrentExamGroup,
  setCurrentExamGroupRightKnee,
  setCurrentExamGroupLeftKnee,
  setCurrentExamGroupDoubleKnee,
} = examGroupSlice.actions;
export const { reducer } = examGroupSlice;
